import { render } from "./AIResultDialog.vue?vue&type=template&id=67a26d64&scoped=true"
import script from "./AIResultDialog.vue?vue&type=script&lang=js"
export * from "./AIResultDialog.vue?vue&type=script&lang=js"

import "./AIResultDialog.vue?vue&type=style&index=0&id=67a26d64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a26d64"]])

export default __exports__